import Box from '@mui/material/Box';

import { FileSetDto } from 'api';
import { getUrlFileSetDownload } from 'api/ApiUrls';
import { FileDisplayBase } from 'library/components/controls/files/FileDisplayBase';
import {
	DeleteRefreshFunction,
	UnitFileRemoveButton,
} from 'library/components/controls/files/UnitFileRemoveButton';
import { getFileType } from 'library/components/controls/files/functions';

export const FilesDisplay = ({
	fileSet,
	onDelete,
}: {
	fileSet: FileSetDto | null | undefined;
} & DeleteRefreshFunction): React.JSX.Element | null => {
	if (fileSet == null) {
		return null;
	}

	return (
		<Box
			sx={{
				display: 'grid',
				gap: 1,
				mb: 4,
			}}>
			{fileSet.files.map((file) => (
				<Box
					key={file.id}
					sx={{
						display: 'flex',
					}}>
					<FileDisplayBase
						key={file.id}
						name={file.fileName}
						type={getFileType(file.fileName)}
						url={getUrlFileSetDownload(fileSet.id, file.id)}
						sx={(theme) => ({
							[theme.breakpoints.only('xs')]: {
								flex: '1',
							},
						})}
					/>
					<UnitFileRemoveButton
						fileSetId={fileSet.id}
						fileId={file.id}
						onDelete={onDelete}
					/>
				</Box>
			))}
		</Box>
	);
};
